import React from 'react'
import { Grid, Typography, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Newsletter from '../../components/Newsletter'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'
import {
  defaultGetStaticPaths,
  getLocaleFromContext
} from '../../utils/staticGeneration'
import { GetStaticProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

// Default static site generation.
export const getStaticPaths = defaultGetStaticPaths
export const getStaticProps: GetStaticProps = async (context) => ({
  props: {
    ...(await serverSideTranslations(getLocaleFromContext(context), ['common']))
  }
})

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    margin: theme.spacing(10, 0, 0, 0),
    maxWidth: '600px',
    color: theme.palette.primary.main
  },
  heading: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(3)
  },
  p: {
    lineHeight: 1.5,
    marginTop: '8px',
    marginBottom: '8px',
    width: '100%',
    whiteSpace: 'pre-line',
    fontSize: '1.2rem'
  }
}))

const About: NextPage = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  return (
    <>
      <Head>
        <title>{t('About us')} - Live Klassisk</title>
        <meta
          name='description'
          content={t(
            'Live Klassisk – the digital concert calendar for classical music in Scandinavia. We make classical concerts, festivals, ensembles and venues more visible to all!'
          )}
        />
      </Head>
      <Container className={classes.root}>
        <Grid container justifyContent='center'>
          <Grid container className={classes.container}>
            <Typography variant='h2' className={classes.heading}>
              {t('About us')}
            </Typography>
            <Typography variant='body1' className={classes.p}>
              {t(
                'Welcome to Live Klassisk – the digital concert calendar for classical music in Scandinavia.\n\nThe professional classical music scene in Scandinavia is rich and vibrant with thousands of concerts each year.\n\nAt Live Klassisk it is our vision to make classical music in Scandinavia more accessible, and the many classical festivals, big symphony orchestras, ensembles and beautiful concert halls more visible for all.\n\nAt the same time we wish to promote greater collaboration between all cultural institutions and ensembles in Scandinavia so we can help each other in spreading the joy of classical music.\n\nLive Klassisk is led by a team of passionate young entrepreneurs and classical musicians from Denmark, Sweden and Norway.\n\nThe project is supported by Kulturrådet – Arts Council Norway – and will always be free to use for all concert-goers.\n\nSee you soon – digitally and out at live classical concerts!'
              )}
            </Typography>
          </Grid>
          <Newsletter />
        </Grid>
      </Container>
    </>
  )
}

export default About
